import { FormattedMessage } from 'react-intl';
import React from 'react';
import { RECENT_VIEW_ID, SHIPPED_VIEW_ID } from './view-id-constants';

export const Recent = {
  label: <FormattedMessage defaultMessage='Recent' description='ordersPage.nav.recent' id='JPiatG' />,
  id: RECENT_VIEW_ID,
  expandedDescription: <FormattedMessage defaultMessage='Shipped / Recent' description='ordersPage.nav.recentExpanded' id='LcqUk3' />,
  parentId: SHIPPED_VIEW_ID,
};
